import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from '@/views/Landing'

Vue.use(VueRouter)

export default new VueRouter({
   mode: 'history',
   routes: [{
         path: '/',
         component: Landing
      },
      {
         path: '/explore',
         component: () => import ('@/views/Explorer')
      },
      {
         path: '/privacy',
         component: () =>
            import ('@/views/Privacy')
      }
   ]
})


// WEBPACK FOOTER //
// ./src/router/index.js